/* Cobra — titulo da PDP personalizado pela arma do cliente (?arma=...).
   O produto cobre varios modelos (ex.: "para Glock G19/G23/G25/G44/G45"); quando o
   cliente chega por um link que informa a arma dele (configurador), mostramos o titulo
   com SO o modelo dele + a linha "Tambem serve: ...".
   REGRA DE OURO: so troca se a arma casar com o metafield armas_compativeis (JSON
   embutido pelo main-product.liquid) — nunca inventa compatibilidade. Sem match ou sem
   parametro, a pagina fica exatamente como e. Apresentacao apenas: SEO/canonical/
   catalogo intocados. */
(function () {
  var param;
  try { param = new URLSearchParams(window.location.search).get('arma'); } catch (e) { return; }
  if (!param) return;

  var dataEl = document.querySelector('[data-armas-compativeis]');
  if (!dataEl) return;
  var lista;
  try { lista = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!Array.isArray(lista) || !lista.length) return;

  function norm(s) {
    return String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/\s+/g, ' ').trim();
  }

  /* match por tokens: "g23" ou "glock g23" casam com "Glock G23"; "g2" nao casa */
  var alvo = norm(param).split(' ');
  var match = null;
  for (var i = 0; i < lista.length; i++) {
    var toks = norm(lista[i]).split(' ');
    var ok = alvo.every(function (t) { return toks.indexOf(t) !== -1; });
    if (ok) { match = lista[i]; break; }
  }
  if (!match) return;

  /* "Coldre Velado para <modelos> [com Lanterna X] — Kydex" -> troca so o miolo */
  var re = /^(.*? para )(.+?)( com .+| — .+| – .+)$/;
  function trocaTitulo(el) {
    if (!el) return false;
    var m = el.textContent.trim().match(re);
    if (!m) return false;
    el.textContent = m[1] + match + m[3];
    return true;
  }

  var trocou = false;
  if (trocaTitulo(document.querySelector('.product__title h1'))) trocou = true;
  if (trocaTitulo(document.querySelector('.cobra-titulo-mobile'))) trocou = true;
  if (!trocou) return;

  var dt = document.title.match(re);
  if (dt) document.title = dt[1] + match + dt[3];

  /* "Tambem serve: G19, G25, ..." — honestidade sobre os demais modelos */
  var outros = lista.filter(function (x) { return x !== match; });
  if (!outros.length) return;
  var marca = match.split(' ')[0];
  var nomes = outros.map(function (x) {
    return x.indexOf(marca + ' ') === 0 ? x.slice(marca.length + 1) : x;
  });
  /* CLS: o Liquid ja deixa o <p class="cobra-arma-tambem"> vazio no lugar certo, com a
     altura reservada (ver cobra-galeria.css). Preenchemos ele; so criamos do zero se o
     marcador nao existir — o que deixa o comportamento antigo como rede de seguranca. */
  function insereApos(el, escopo) {
    if (!el) return;
    var sel = '.cobra-arma-tambem' + (escopo ? '.cobra-arma-tambem--' + escopo : ':not(.cobra-arma-tambem--mobile)');
    var p = el.parentNode && el.parentNode.querySelector(sel);
    if (!p) {
      p = document.createElement('p');
      p.className = 'cobra-arma-tambem' + (escopo ? ' cobra-arma-tambem--' + escopo : '');
      el.insertAdjacentElement('afterend', p);
    }
    p.textContent = 'Também serve: ' + nomes.join(', ');
  }
  /* desktop: dentro do .product__title (que o mobile ja esconde por inteiro) */
  insereApos(document.querySelector('.product__title h1'));
  /* mobile: apos a linha de estrelas/disponibilidade (ou o titulo compacto) */
  insereApos(
    document.querySelector('.cobra-header-linha') || document.querySelector('.cobra-titulo-mobile'),
    'mobile'
  );
})();
